import { GetInitialDataCtx, WidgetProps } from "../../contracts/widget"
import { reviewsWidgetConfig, ReviewsWidgetConfig } from "./config"
import { WidgetProvider } from "../../providers/widget"
import { ReviewsWidgetContent } from "./components/ReviewsWidgetContent"
import "./reviews.css"
import { useMemo } from "react"
import { parseWidgetConfig } from "@homerunner-next/widget-core/schema"

export const getInitialData = async ({ options, feedId, widgetId }: GetInitialDataCtx<ReviewsWidgetConfig>) => {
    return {}
}

export default function ReviewsWidget({ options, feedId, widgetId, resolvedTheme, data }: WidgetProps<ReviewsWidgetConfig>) {
    const parsedOptions = useMemo(() => parseWidgetConfig(reviewsWidgetConfig, options), [options])
    return (
        <WidgetProvider options={parsedOptions} feedId={feedId} widgetId={widgetId} resolvedTheme={resolvedTheme} widgetType="reviews" data={data ?? {}}>
            <ReviewsWidgetContent />
        </WidgetProvider>
    )
}
